import {
  FETCH_ADDONS,
  FETCH_ADDONS_SUCCESS,
  FETCH_ADDONS_FAILED,
  EDIT_ADDONS,
} from "../store/types";

import store from "../store/store";
import { firebase } from "../config/configureFirebase";
import { onValue, set, update } from "firebase/database";

export const fetchAddons = () => (dispatch) => {
  const { settingsRef } = firebase;

  dispatch({
    type: FETCH_ADDONS,
    payload: null,
  });

  onValue(settingsRef, (snapshot) => {
    if (snapshot.val()) {
      const settings = snapshot.val();
      // Extract addons data from settings
      const addonsData = {
        sub_admin_controls: settings.sub_admin_controls || false,
        manual_withdraw_add_on: settings.manual_withdraw_add_on || false,
        new_booking_history_design:
          settings.new_booking_history_design || false,
        support_module_enabled: settings.support_module_enabled || false,
        sos_enabled: settings.sos_enabled || false,
        emergency_message_enabled: settings.emergency_message_enabled || false,
        travel_route_addon_enabled:
          settings.travel_route_addon_enabled || false,
        admin_queue_addon_enabled: settings.admin_queue_addon_enabled || false,
        waze_navigation_enabled: settings.waze_navigation_enabled || false,
        restricted_countries: settings.restricted_countries || false,
        subscription_required: settings.subscription_required || false,
        subscription_required_active:
          settings.subscription_required_active || false,
        enable_subscriptions: settings.enable_subscriptions || false,
        feedback_review_module_enabled:
          settings.feedback_review_module_enabled || false,
        enable_pay_with_point: settings.enable_pay_with_point || false,
        showWalletHistory: settings.showWalletHistory || false,
        customerNewUi: settings.customerNewUi || false,
        emergencyButtonSettings: settings.emergencyButtonSettings || false,
      };

      dispatch({
        type: FETCH_ADDONS_SUCCESS,
        payload: addonsData,
      });
    } else {
      dispatch({
        type: FETCH_ADDONS_FAILED,
        payload: "Unable to fetch addons data from settings.",
      });
    }
  });
};

export const editAddons = (addonsData) => async (dispatch) => {
  const { settingsRef } = firebase;

  try {
    dispatch({
      type: EDIT_ADDONS,
      payload: addonsData,
    });

    // Update addons data in Firebase settings
    await update(settingsRef, addonsData);

    console.log("✅ Addons data updated successfully:", addonsData);
  } catch (error) {
    console.error("❌ Error updating addons data:", error);
    dispatch({
      type: FETCH_ADDONS_FAILED,
      payload: error.message,
    });
  }
};
